// ENUMS #############################################################
import { TemplateRef } from '@angular/core';

export enum ParameterizedHtmlTextValueTypeEnum {
	STRING = 'string',
	TEMPLATE_REF = 'templateRef'
}


// INTERFACES ########################################################
export interface IParameterizedHtmlTextTemplateRefData {
	[ key: string ]: TemplateRef<HTMLElement>;
}


export interface IParameterizedHtmlTextItemString {
	value: string;
	valueType: ParameterizedHtmlTextValueTypeEnum.STRING;
}

export interface IParameterizedHtmlTextItemTemplateRef {
	value: TemplateRef<HTMLElement>;
	valueType: ParameterizedHtmlTextValueTypeEnum.TEMPLATE_REF;
}


// TYPES #############################################################
export type ParameterizedHtmlTextType =
	IParameterizedHtmlTextItemString
	| IParameterizedHtmlTextItemTemplateRef;
